export const RepositoryUsers = {
  namespaced: true,

  state: {
    users: [],
    usersLoaded: false,
    usersLoading: false,
  },

  getters: {
    getRepositoryUsers: ({ users }) => users,
    areUsersLoaded: ({ usersLoaded }) => usersLoaded,
    areUsersLoading: ({ usersLoading }) => usersLoading,
  },

  mutations: {
    setLoading(state, loading) {
      state.usersLoading = loading;
    },

    setLoaded(state, loaded) {
      state.usersLoaded = loaded;
    },

    setUsers(state, users) {
      state.users = [...users];
    },
  },

  actions: {
    async loadUsersForRepository({ commit }, repository) {
      let users = [];

      commit('setLoading', true);

      try {
        const response = await this._vm.$api('repositories.users.index', {
          version: '1.0',
          repository,
        });

        users = response?.data?.data ?? [];
      } catch (err) {
        console.error(err);
      }

      commit('setUsers', users);
      commit('setLoading', false);
      commit('setLoaded', true);
    },
  },
};
